module.exports = __webpack_public_path__ + "img/14-mob.d077083e.png";